export default __webpack_public_path__ + "static/media/photo--lg--37.7822fa09.jpg";